import { Input } from 'antd';
import styled from 'styled-components';

export const CustomInputStyled = styled(Input.Password)`
  height: 40px;
  font-size: 16px;
`;
